import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./AppBanner.css";

const AppBanner = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // localStorage'dan banner durumunu kontrol et
    const bannerDismissed = localStorage.getItem("appBannerDismissed");

    // Eğer daha önce kapatılmamışsa göster
    if (!bannerDismissed) {
      // Sayfa yüklendikten 1 saniye sonra göster (daha iyi UX)
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // Kullanıcı kapattığında localStorage'a kaydet
    localStorage.setItem("appBannerDismissed", "true");
  };

  const handleOpenApp = () => {
    // Uygulama linkine yönlendir ve banner'ı kapat
    localStorage.setItem("appBannerDismissed", "true");

    // iOS için App Store linki
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);

    if (isIOS) {
      window.location.href =
        "https://apps.apple.com/us/app/mukemel/id6753164005";
    } else if (isAndroid) {
      // Android için Google Play linki (yakında)
      window.location.href = "/application";
    } else {
      // Masaüstü için uygulama sayfasına yönlendir
      window.location.href =
        "https://apps.apple.com/us/app/mukemel/id6753164005";
    }
  };

  if (!isVisible) return null;

  return (
    <div className="app-banner-overlay">
      <div className="app-banner-container">
        <button
          className="app-banner-close"
          onClick={handleClose}
          aria-label={t("common.close") || "Kapat"}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>

        <div className="app-banner-content">
          <div className="app-banner-text">
            <span>
              {t("appBanner.title") || "Mobil Uygulamamızı Denediniz mi?"}
            </span>
          </div>

          <button className="app-banner-button" onClick={handleOpenApp}>
            {t("appBanner.openApp") || "Mobil uygulamada aç"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppBanner;
